import { User } from '../../entities/User';
import { api } from '../api';

export const getUserById = async (id: string) => {
  const { data }: { data: User } = await api.get(`/users/${id}`);

  return data;
};
